<template>
  <header class="header">
    <div class="header_logo">
      <div class="container">
        <div class="row ">
          <div class="logo_musiconn">
            <a href="https://www.musiconn.de/index.php" target="_blank">
              <img src="logo_musiconn.png" height="68px" class="logo1" />
              <img src="musiconn_mit_sinus.svg" class="logo2" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "FleischmannHeader",
  data() {
    return {};
  },
};
</script>

<style scoped>
.header_logo {
  background-color: #005be3;
  height: 52px;
  margin-top: 30px;
}
.logo_musiconn {
  margin: -16px;
}
.logo2 {
  display: none;
  padding-bottom: 10px;
}
@media (max-width: 991px) {
  .header_logo {
    background-color: white;
    height: 104px;
  }
  .logo1 {
    display: none;
  }
  .logo2 {
    display: block;
    height: 104px;
  }
  .logo_musiconn {
    margin: 0px;
  }
  .row {
    justify-content: center;
  }
}
</style>
